export default __webpack_public_path__ + "static/media/resume.9cb457c6.pdf";